<div class="flex flex-col md:flex-row min-h-screen bg-white">
  <!-- Sidebar para desktop -->
  <app-sidebar
    [circleNumber]="3"
    (backClick)="goBack()"
    class="bg-teu-purple hidden sm:block relative w-full md:w-[197px] h-[120px] md:h-auto flex-shrink-0 overflow-hidden">
  </app-sidebar>

  <!-- Header para móvil -->
  <app-header [circleNumber]="3" (backClick)="goBack()"></app-header>

  <!-- Main Content -->
  <div class="flex-1 flex flex-col">
    <app-subheader [circleNumber]="3" class="pt-[60px] md:pt-0"></app-subheader>

    <!-- Contenedor principal (con safe-area inferior) -->
    <div
      class="w-full xl:max-w-[800px] mx-auto px-4 sm:px-6 md:px-8 pb-28 md:pb-16"
      style="padding-bottom: calc(env(safe-area-inset-bottom, 0px) + 88px);"
    >
      <!-- Aquí va tu contenido actual (instrucción + óvalo con cámara) -->
      <!-- Recomendación: eliminar el botón flotante “X” para no duplicar navegación -->
      <div class="pt-16 pb-6 px-6">
        <p class="text-center font-semibold uppercase tracking-wide text-rose-500">
          Enfoca la cámara y no se mueva
        </p>
      </div>

      <!-- Contenedor de cámara en óvalo -->
      <div class="w-full flex justify-center px-6">
        <div class="w-[260px] h-[340px] md:w-[300px] md:h-[400px] rounded-full overflow-hidden border-4 border-gray-200 shadow-lg">
          <video #videoEl
                 class="w-full h-full object-cover transform -scale-x-100"
                 autoplay
                 playsinline
                 muted>
          </video>
        </div>
      </div>

      <!-- Mensaje de error (si falla la cámara) -->
      <div *ngIf="cameraError" class="mt-6 px-6">
        <p class="text-center text-sm text-red-600">{{ cameraError }}</p>
      </div>

      <!-- Botón Continuar -->
      <div class="pt-8 flex justify-center">
        <button
          type="button"
          class="btn-primary w-full max-w-[300px] h-[46px]"
          (click)="onContinue()"
        >
          Continuar
        </button>
      </div>
    </div>
  </div>
</div>